export class CustomerWallet {
    loyaltyWallet: number;
    eventWallet: number;
    activityWallet: number;
    referWallet: number;
}